import { Contact } from "@/sections/Contact";

export default function ContactPage() {
  return (
    <main data-testid="contact-page" className="pt-24">
      <Contact />
    </main>
  );
}
